import { useEffect } from 'react';

const useHotkeyActions = (hotkeys, actionHandlers) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            const keys = [];

            if (e.ctrlKey) keys.push('Ctrl');
            if (e.shiftKey) keys.push('Shift');
            if (e.altKey) keys.push('Alt');
            if (e.metaKey) keys.push('Meta');

            let key = '';
            if (e.code === 'Space') {
                key = 'Space';
            } else if (typeof e.key === 'string') {
                key = e.key.length === 1 ? e.key.toUpperCase() : e.key;
            } else {
                key = e.code || '';
            }

            if (!['CONTROL', 'SHIFT', 'ALT', 'META'].includes(key.toUpperCase())) {
                keys.push(key);
            }

            const combo = keys.join('+');

            const matched = hotkeys.find(hk => hk.hotkey === combo);
            if (matched && actionHandlers[matched.action]) {
                e.preventDefault();
                actionHandlers[matched.action]();
            }
        };

        window.addEventListener('keydown', handleKeyDown, true);
        return () => window.removeEventListener('keydown', handleKeyDown, true);
    }, [hotkeys, actionHandlers]);
};

export default useHotkeyActions;



// WEBPACK FOOTER //
// ./src/utils/useHotkeyAction.js